module.exports = __webpack_public_path__ + "static/media/JP.353bec03.svg";